<form class='vc'
	*ngIf='vcCategories'
	[@fadeInOut]
	cdkTrapFocus>

	<div class='vc-header'>

		<div class='vc-cats'>
			<!-- Register list of categories with icons -->
			<ng-container *ngFor='let category of vcCategories; let i = index'>
				<div class='vc-cat'
					tabindex='0'
					(keydown.enter)='activateCat( i )'
					(click)='activateCat( i )'
					[class.vc-cat-active]='activeCat === i'>
					<div class='vc-cat-icon'>
						<mat-icon svgIcon='vc:cat-{{category.svg}}' class=''></mat-icon>
					</div>
					<div class='vc-cat-title'
						[innerHtml]='category.category'></div>
				</div>
			</ng-container>
		</div>

		<!-- Only on mobile -->
		<div class='vc-header-mobile'>
			<div class='vc-title' i18n>Select a <span class='color-blue'>room</span>, or
				<span class='color-blue'>search</span> for an item to get started
			</div>
		</div>

		<button type='button' class='vc-close' *ngIf='vcCategories' [mat-dialog-close]>
			<mat-icon svgIcon='vc:close'></mat-icon>
		</button>

	</div>

	<form [formGroup]='volumeCalculatorForm' class='vc-body' #vcBody>
		<div class='vc-cats'>

			<!-- Looping categories -->
			<ng-container *ngFor='let category of vcCategories; let catIndex = index'>

				<!-- Only on mobile -->
				<div class='vc-cat'
					id='vc-cat-mobile-{{catIndex}}'
					(click)='toggleCatMobile( catIndex )'
					[class.vc-cat-active]='activeCatMobile === catIndex'>
					<div class='vc-cat-align-left'>
						<div class='vc-cat-icon'>
							<mat-icon svgIcon='vc:cat-{{category.svg}}' class=''></mat-icon>
						</div>
						<div class='vc-cat-title' [innerHtml]='category.category'></div>
					</div>
					<div class='vc-cat-align-right'>
						<div class='vc-cat-arrow'>
							<mat-icon svgIcon='vc:arrow-down'></mat-icon>
						</div>
					</div>
				</div>
				<div class='vc-cat-items'
					[class.vc-cat-items-active]='activeCat === catIndex'
					[class.vc-cat-items-active-mobile]='activeCatMobile === catIndex'>
					<ng-container *ngFor='let item of category.items; let itemIndex = index'>
						<div class='vc-item vc-item-key-{{catIndex}}-{{itemIndex}}'>
							<div class='vc-item-align-left'>
								<div class='vc-item-title'
									(click)='itemUpInit( catIndex, itemIndex )'
									[style.font-weight]='itemHasValue( catIndex, itemIndex ) ? "600" : "400"'>
									<span [innerHtml]='item.name'></span></div>
							</div>
							<div class='vc-item-align-right'>
								<div class='vc-item-actions'>
									<div class='vc-item-actions-minus'
										tabindex='0'
										(keydown.enter)='itemDown( catIndex, itemIndex )'
										(click)='itemDown( catIndex, itemIndex )'
										[class]='itemHasValue( catIndex, itemIndex ) ? "" : "inactive"'>
										<mat-icon svgIcon='vc:minus'></mat-icon>
									</div>
									<div class='vc-item-actions-count'>
										<input
											type='number'
											(blur)='itemInput( $event, catIndex, itemIndex )'
											[value]='this.volumeCalculatorForm.controls[catIndex + "-" +itemIndex].value'
											min='0'
											oninput="validity.valid||(value='');">
									</div>
									<div class='vc-item-actions-plus'
										tabindex='0'
										(keydown.enter)='itemUp( catIndex, itemIndex )'
										(click)='itemUp( catIndex, itemIndex )'>
										<mat-icon svgIcon='vc:plus' class=''></mat-icon>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>

			</ng-container>
		</div>
	</form>
	<div class='vc-footer'>
		<div class='vc-search'
			#vcSearchRef>
			<mat-form-field>
				<mat-label i18n='@@labelFindItems'>Find items</mat-label>
				<input type='text'
					#vcSearchInput
					(keyup)='vcSearch( $event )'
					matInput
					placeholder='Search'
					i18n-placeholder='@@placeholderSearch'>
			</mat-form-field>
			<div *ngIf='vcSearchResults.length'
				class='vc-search-results'>
				<ng-container *ngFor='let item of vcSearchResults'>
					<div class='vc-item vc-item-key-{{item.catIndex}}-{{item.itemIndex}}'>
						<div class='vc-item-align-left'>
							<div class='vc-item-title'
								(click)='itemUpInit( item.catIndex, item.itemIndex )'
								[style.font-weight]='itemHasValue( item.catIndex, item.itemIndex ) ? "600" : "400"'>
								<span [innerHtml]='item.name'></span><span *ngIf='item.duplicate'> ({{item.catName}})</span>
							</div>
						</div>
						<div class='vc-item-align-right'>
							<div class='vc-item-actions'>
								<div class='vc-item-actions-minus' (click)='itemDown( item.catIndex, item.itemIndex )'
									[class]='itemHasValue( item.catIndex, item.itemIndex ) ? "" : "inactive"'>
									<mat-icon svgIcon='vc:minus'></mat-icon>
								</div>
								<div class='vc-item-actions-count'>
									<input type='number' (blur)='itemInput( $event, item.catIndex, item.itemIndex )'
										[value]='this.volumeCalculatorForm.controls[item.catIndex + "-" +item.itemIndex].value'
										min='0'
										oninput="validity.valid||(value='');">
								</div>
								<div class='vc-item-actions-plus' (click)='itemUp( item.catIndex, item.itemIndex )'>
									<mat-icon svgIcon='vc:plus' class=''></mat-icon>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class='vc-results'>
			<div class='vc-sir-leo-headshot'>
				<mat-icon svgIcon='icons:sir-leo-headshot' class=''></mat-icon>
			</div>
			<div class='vc-total'>

				<ng-container *ngFor='let item of formService.getVolumeOrder()'>

					<div *ngIf='item == "ft3"' class='vc-total-number'><span id='vc-ft3'>{{vcFt3}}</span>ft³</div>
					<div *ngIf='item == "divider"' class='vc-total-divider'>
						<mat-icon svgIcon='vc:divider'></mat-icon>
					</div>
					<div *ngIf='item == "m3"' class='vc-total-number'><span id='vc-m3'>{{vcM3}}</span>m³</div>

				</ng-container>

			</div>
		</div>
		<div class='vc-actions'>
			<button type='button' (click)='calculateTotal()' [mat-dialog-close] i18n='buttonSaveVolume'>Save calculation</button>
		</div>
	</div>

</form>

<div class='vc-loading'
	*ngIf='!vcCategories'>
	<div class='lds-ellipsis'>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>
